import React from 'react';
import ForgotUserNameForm from "../../components/forgot-user-name/ForgotUserNameForm";

const ForgotUserName = (props) => (
    <ForgotUserNameForm {...props} />
);

export default ForgotUserName;